import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { ResponseBase, ScreenModel,ResponseData } from '../../../../core/models/common';
import {
  QuestionList,
  QuestionServerData,
  QuestionSubmitData,
} from '../../../../core/models/fna';
import { ApiService } from '../../../../core/services/api-mock.service';
import { GlobalsService } from '../../../../core/services/globals.service';

// What we receive from the API, and will send to the API.
export interface RiskAndObjectivesData extends ResponseBase {
  QuestionList: QuestionServerData[];
}

// What we work with in this screen.
export class RiskAndObjectivesModel extends ScreenModel {
  screenName = 'RiskAndObjectives';
  pageID_read = 'R0060';
  pageID_write = 'S0060';
  data: ResponseBase | undefined;
  questionList: QuestionList[] = [];


  // region Data lifecycle

  mapPegaObjToUI(data : any){
    console.log("FIRSTEVER MAPPING TEST +++++++")
    console.log(data)
    let riskQuestionList = data['RiskandObjectiveDetails']['RiskandObjectives']
    let masterArray:QuestionServerData[] = [];
    let qIndex = 0;
    for(let i = 0; i<riskQuestionList.length;++i){
      let groupArray = riskQuestionList[i].RiskQuestions.map((questionObj:any)=>{

        return {
        
          Id: ""+qIndex++,
          Label: questionObj.Question,
          SelectedOption: (()=>{
            let selectedIndex = undefined;
            questionObj.RiskQuestionOptions.forEach((option:any,index:number)=>{
              
              if(option.IsSelected){
                selectedIndex =  index;
                
              }
            })
            
            return selectedIndex+"" == "undefined"?undefined:selectedIndex+""
          })(),
          Options: questionObj.RiskQuestionOptions.map((optionObj:any,index:number)=>{
            
            return{
              Id: ""+index,
              Title: optionObj.RiskOption,
              Description: '',
            }
          }),
          Category: riskQuestionList[i].SectionName
        
      }
      })

      masterArray = masterArray.concat(groupArray)
      
    }

     let riskAndObjectivesData:RiskAndObjectivesData  = {
      QuestionList: masterArray 
     }
     
     return riskAndObjectivesData;
   }
  deriveFromData(data: RiskAndObjectivesData) {
    
    this.questionList = data.QuestionList.reduce(
      (previousValue: QuestionList[], currentValue, index) => {
        let existingCategory = previousValue.find(
          (a: QuestionList) => a.category === currentValue.Category,
        );

        if (!existingCategory) {
          existingCategory = {
            category: currentValue.Category,
            questions: [],
          };

          previousValue.push(existingCategory);
        }

        existingCategory.questions.push({
          id: currentValue.Id,
          index: index,
          label: currentValue.Label,
          selectedOption: currentValue.SelectedOption,
          options: currentValue.Options.map((option) => ({
            id: option.Id,
            title: option.Title,
            description: option.Description,
          })),
        });

        return previousValue;
      },
      [],
    );
    console.log('deriveFromData, model:', this);
  }

  // Constructs a JSON object to be sent to server.
  deriveDataFromModel(): any {
    // @For integration.
    console.log('this.form.values:', this.form);

    const result: QuestionSubmitData[] = [];
    this.form?.value.questions.forEach((question: any) => {
      const keys = Object.keys(question);

      keys.forEach((key) => {
        result.push({
          Id: key,
          SelectedOption: question[key],
        });
      });
    });

    console.log("RESULT ;;; ")
    console.log(result)

    let riskQuestionList = (this.data as ResponseData).ServiceBody['RiskandObjectiveDetails']['RiskandObjectives']
    
    let qIndex = 0;
    for(let i = 0; i<riskQuestionList.length;++i){
      riskQuestionList[i].RiskQuestions.forEach((questionObj:any)=>{

       console.log("Apostphe--------------DEBUG&#2019;")
       console.log(questionObj.Question.indexOf("'"))
       questionObj.RiskQuestionOptions.forEach((option:any)=>{
         option.IsSelected = false;
       })
        questionObj.RiskQuestionOptions[result[qIndex].SelectedOption].IsSelected = true;
        ++qIndex;
      })

     
      
    }

    return {
      ServiceBody :(this.data as ResponseData).ServiceBody// this.isQualifiedAccreditedInvestor}
    };
  }

  // endregion Data lifecycle

  syncModelWithForm() {
    console.log('[RiskAndObjectivesModel] syncModelWithForm');
    // console.log('Form Values: ', formValues);
  }

  validate() {
    if (!this.isSubmitted) {
      return;
    }

    if (!this.form) {
      return;
    }

    this.isValid = this.form.valid;
  }
}
@Component({
  selector: 'app-risk-and-objectives',
  templateUrl: './risk-and-objectives.component.html',
  styleUrls: ['./risk-and-objectives.component.scss'],
})
export class RiskAndObjectivesComponent implements OnInit {
  model = new RiskAndObjectivesModel(this.globals, this.apiService, this.el);
  form: FormGroup = this.formBuilder.group({
    questions: this.formBuilder.array([]),
  });

  constructor(
    private router: Router,
    public globals: GlobalsService,
    protected apiService: ApiService,
    private formBuilder: FormBuilder,
    private el: ElementRef,
  ) {
    this.model.form = this.form;
    this.model.initializeForm = this.initializeForm;
    this.model.goToNextScreen = this.goToNextScreen;
    this.model.goToPreviousScreen = this.goToPreviousScreen;
  }

  async ngOnInit() {
    await this.model.loadData();
    
  }
  // ngDoCheck(){
  //   debugger
  // }
  // ngAfterContentInit(){
  //   debugger
  // }
  // ngAfterContentChecked(){
  //   debugger
  // }
  // ngAfterViewInit(){
  //   debugger
  // }
  // ngAfterViewChecked(){
  //   debugger
  // }
  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload($event: any) {
    $event.returnValue =
      'Changes to your data will be lost! Are you sure you want to exit?';
  }

  initializeForm = () => {
    console.log('this.model.questions: ', this.model.questionList);
    this.model.questionList.forEach((questionList) => {
      this.questionsFormArray.push(this.buildQuestionFormGroup(questionList));
    });
  };

  buildQuestionFormGroup(questionList: QuestionList): FormGroup {
    const group = this.formBuilder.group([]);
    questionList.questions.map((question) => {
      group.addControl(
        String(question.id),
        new FormControl(question.selectedOption, [Validators.required]),
      );
    });

    return group;
  }

  goToNextScreen = async () => {
    console.log('[RiskAndObjectives] goToNextScreen');
    await this.router.navigateByUrl('/fna/risk-profile-assessment');
  };

  goToPreviousScreen = async () => {
    console.log('[RiskAndObjectives] goToPreviousScreen');
    await this.router.navigateByUrl('/fna/financial-situation');
  };

  // region Form controls

  get questionsFormArray() {
    return this.form.get('questions') as FormArray;
  }

  // endregion Form controls end

  // region mock
  fillFormWithMockData() {
    this.questionsFormArray.controls.forEach((control, index) => {
      const group = control as FormGroup;
      if (!group) {
        return;
      }

      const question = this.model.questionList[index];

      question.questions.forEach((qn) => {
        const childControl = group.controls[qn.id];
        const optionIdToSelect = qn.options[0].id;
        childControl.setValue(optionIdToSelect);
      });
    });
  }
  // endregion
}
